
import { MedicalProfession } from "@domain/localization/country";
import { Dayjs } from "dayjs";

export interface User {
	id: string;
	email: string;
	firstName: string;
	lastName: string;
	locale: string;
	analyticsId: string;
	isReviewer: boolean;
	isTester: boolean;
	country: string;
	creationDate: Dayjs;
	lastConnectionDate: Dayjs | null;
	hcpValidationDate: Dayjs | null;
	identityValidationDate: Dayjs | null;
	hasAgreedToLegalDocuments: boolean;
	hasIdentityFiles: boolean;
	notificationPreferences: NotificationPreferences[];
	postalCode?: string;
	cityOfPractice?: string;
	medicalProfession?: MedicalProfession;
	professionalId?: {
		name: string;
		value: string;
	};
}

export type UserUpdateData = Partial<Pick<User, "firstName" | "lastName" | "postalCode" | "cityOfPractice" | "locale">>;

export interface EmailConsentChoices {
	physioMeEmails: PtNotificationPreferencesStatus;
	biogenEmails: PtNotificationPreferencesStatus;
}

export enum RegistrationStatus {
	PENDING = "PENDING",
	VALIDATED = "VALIDATED",
	REJECTED = "REJECTED",
	INCOMPLETE = "INCOMPLETE",
	ONFIDO_REJECTED = "ONFIDO_REJECTED",
	NOT_NEEDED = "NOT_NEEDED",
}

export type PtStatus = Exclude<RegistrationStatus, RegistrationStatus.ONFIDO_REJECTED>;

export enum IdentityStatus {
	NOT_NEEDED = "NOT_NEEDED",
	PENDING = "PENDING",
	VALIDATED = "VALIDATED",
	INCOMPLETE = "INCOMPLETE",
}

export interface NotificationPreferences {
	type: PtNotificationPreferencesType;
	email: PtNotificationPreferencesStatus;
	web: PtNotificationPreferencesStatus;
}

export enum PtNotificationPreferencesType {
	PHYSIO_ME = "PHYSIO_ME",
	BIOGEN = "BIOGEN",
	PATIENT_PROGRAM_STARTED = "PATIENT_PROGRAM_STARTED",
	PATIENT_PROGRAM_ENDING_SOON = "PATIENT_PROGRAM_ENDING_SOON",
	PATIENT_PROGRAM_ENDED = "PATIENT_PROGRAM_ENDED",
	PATIENT_REGISTERED = "PATIENT_REGISTERED",
	HCT_INVITATION_ACCEPTED = "HCT_INVITATION_ACCEPTED",
	MONTHLY_RECAP = "MONTHLY_RECAP",
}

export enum PtNotificationPreferencesStatus {
	ENABLED = "ENABLED",
	DISABLED = "DISABLED",
	NA = "NA",
}
